import { NoPermissionTranslations } from "./types";

export const deTranslations: NoPermissionTranslations = {
    title: "Sie haben keine Berechtigung, diese Seite zu sehen",
    message:
        "Dies ist der Admin-Bereich. Ihr Konto hat keine Admin-Rolle, daher gibt es hier nichts für Sie.",
    back: "Zurück zur Anmeldung",
};
